function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { BehaviorSubject } from 'rxjs';
import { takeUntil, filter, first } from 'rxjs/operators';
import semverCompare from 'semver-compare';
import { fwupdaterSignatures, oldFwupdaterSignatures } from './signatures';
/* The status of the Firmware Updater Tool */

var FWUToolStatusEnum = Object.freeze({
  NOPE: 'NOPE',
  OK: 'OK',
  CHECKING: 'CHECKING',
  ERROR: 'ERROR DOWNLOADING TOOL'
});
/* The signatures needed to run the commands to use the Firmware Updater Tool */

var signaturesEnum = fwupdaterSignatures;
var updaterBinaryName = 'FirmwareUploader';

var FirmwareUpdater =
/*#__PURE__*/
function () {
  function FirmwareUpdater(Daemon) {
    var _this = this;

    _classCallCheck(this, FirmwareUpdater);

    this.updateStatusEnum = Object.freeze({
      NOPE: 'NOPE',
      STARTED: 'STARTED',
      GETTING_INFO: 'GETTING_INFO',
      GOT_INFO: 'GOT_INFO',
      UPLOADING: 'UPLOADING',
      DONE: 'DONE',
      ERROR: 'ERROR'
    });
    this.Daemon = Daemon;
    this.FWUToolStatus = FWUToolStatusEnum.NOPE;
    this.Daemon.downloadingDone.subscribe(function () {
      _this.FWUToolStatus = FWUToolStatusEnum.OK;
    });
    this.updating = new BehaviorSubject({
      status: this.updateStatusEnum.NOPE
    });
    this.updatingDone = this.updating.pipe(filter(function (update) {
      return update.status === _this.updateStatusEnum.DONE;
    })).pipe(first()).pipe(takeUntil(this.updating.pipe(filter(function (update) {
      return update.status === _this.updateStatusEnum.ERROR;
    }))));
    this.updatingError = this.updating.pipe(filter(function (update) {
      return update.status === _this.updateStatusEnum.ERROR;
    })).pipe(first()).pipe(takeUntil(this.updatingDone));
    this.gotFWInfo = this.updating.pipe(filter(function (update) {
      return update.status === _this.updateStatusEnum.GOT_INFO;
    })).pipe(first()).pipe(takeUntil(this.updatingDone)).pipe(takeUntil(this.updatingError));
  }

  _createClass(FirmwareUpdater, [{
    key: "setToolVersion",
    value: function setToolVersion(version) {
      this.toolVersion = version;

      if (semverCompare(version, '0.1.2') < 0) {
        signaturesEnum = oldFwupdaterSignatures;
        updaterBinaryName = 'updater';
      }
    }
  }, {
    key: "getFirmwareInfo",
    value: function getFirmwareInfo(boardId, port, firmwareVersion) {
      var _this2 = this;

      this.firmwareVersionData = null;
      this.loaderPath = null;
      this.updating.next({
        status: this.updateStatusEnum.GETTING_INFO
      });
      var versionsList = [];
      var firmwareInfoMessagesSubscription;

      var handleFirmwareInfoMessage = function handleFirmwareInfoMessage(message) {
        var versions;

        switch (message.ProgrammerStatus) {
          case 'Starting':
            break;

          case 'Busy':
            if (message.Msg.indexOf('Flashing with command:') >= 0) {
              return;
            }

            versions = JSON.parse(message.Msg);
            Object.keys(versions).forEach(function (v) {
              if (versions[v][0].IsLoader) {
                _this2.loaderPath = versions[v][0].Path;
              } else {
                versionsList = [].concat(_toConsumableArray(versionsList), _toConsumableArray(versions[v]));
              }
            });
            _this2.firmwareVersionData = versionsList.find(function (version) {
              return version.Name.split(' ').splice(-1)[0].trim() === firmwareVersion;
            });

            if (!_this2.firmwareVersionData) {
              _this2.updating.next({
                status: _this2.updateStatusEnum.ERROR,
                err: "Can't get firmware info: couldn't find version '".concat(firmwareVersion, "' for board '").concat(boardId, "'")
              });
            }

            break;

          case 'Error':
            _this2.updating.next({
              status: _this2.updateStatusEnum.ERROR,
              err: "Couldn't get firmware info: ".concat(message.Msg)
            });

            firmwareInfoMessagesSubscription.unsubscribe();
            break;

          case 'Done':
            firmwareInfoMessagesSubscription.unsubscribe();

            _this2.updating.next({
              status: _this2.updateStatusEnum.GOT_INFO
            });

            break;

          default:
            break;
        }
      };

      if (this.FWUToolStatus !== FWUToolStatusEnum.OK) {
        this.updating.next({
          status: this.updateStatusEnum.ERROR,
          err: "Can't get firmware info: couldn't find firmware updater tool"
        });
        return;
      }

      firmwareInfoMessagesSubscription = this.Daemon.appMessages.subscribe(function (message) {
        if (message.ProgrammerStatus) {
          handleFirmwareInfoMessage(message);
        }
      });
      var data = {
        board: boardId,
        port: port,
        commandline: "\"{runtime.tools.fwupdater.path}/".concat(updaterBinaryName, "\" -get_available_for {network.password}"),
        signature: signaturesEnum.GET_FIRMWARE_INFO,
        extra: {
          auth: {
            password: boardId
          }
        },
        filename: 'ListFirmwareVersionsInfo.bin'
      };
      return fetch("".concat(this.Daemon.pluginURL, "/upload"), {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain; charset=utf-8'
        },
        body: JSON.stringify(data)
      }).then(function (response) {
        if (!response.ok) {
          _this2.updating.next({
            status: _this2.updateStatusEnum.ERROR,
            err: "Error fetching ".concat(_this2.Daemon.pluginURL, "/upload")
          });
        }
      })["catch"](function () {
        _this2.updating.next({
          status: _this2.updateStatusEnum.ERROR,
          err: "Coudln't list firmware versions info."
        });
      });
    }
  }, {
    key: "updateFirmware",
    value: function updateFirmware(boardId, port, firmwareVersion) {
      var _this3 = this;

      this.updating.next({
        status: this.updateStatusEnum.STARTED
      });
      this.Daemon.closeSerialMonitor(port);
      this.Daemon.serialMonitorOpened.pipe(filter(function (open) {
        return !open;
      })).pipe(first()).subscribe(function () {
        if (!port) {
          _this3.updating.next({
            status: _this3.updateStatusEnum.ERROR,
            err: "Can't update Firmware: no port selected."
          });

          return;
        }

        _this3.gotFWInfo.subscribe(function () {
          if (!_this3.firmwareVersionData) {
            _this3.updating.next({
              status: _this3.updateStatusEnum.ERROR,
              err: "Can't update Firmware: couldn't find version '".concat(firmwareVersion, "' for board '").concat(boardId, "'")
            });

            return;
          }

          var updateFirmwareMessagesSubscription;

          var handleFirmwareUpdateMessage = function handleFirmwareUpdateMessage(message) {
            switch (message.ProgrammerStatus) {
              case 'Error':
                _this3.updating.next({
                  status: _this3.updateStatusEnum.ERROR,
                  err: "Can't update Firmware: ".concat(message.Msg)
                });

                updateFirmwareMessagesSubscription.unsubscribe();
                break;

              case 'Done':
                _this3.updating.next({
                  status: _this3.updateStatusEnum.DONE
                });

                updateFirmwareMessagesSubscription.unsubscribe();
                break;

              default:
                break;
            }
          };

          updateFirmwareMessagesSubscription = _this3.Daemon.appMessages.subscribe(function (message) {
            if (message.ProgrammerStatus) {
              handleFirmwareUpdateMessage(message);
            }
          });
          var addresses = '';
          var rootCertificates = [{
            domain: 'arduino.cc',
            port: 443
          }];
          rootCertificates.forEach(function (address) {
            if (address.domain && address.port) {
              addresses += "-address ".concat(address.domain, ":").concat(address.port, " ");
            }
          });
          var isUsingAvrdude = boardId === 'uno2018';
          var programmer = isUsingAvrdude ? '{runtime.tools.avrdude}/bin/avrdude' : '{runtime.tools.bossac}/bossac';

          if (!_this3.loaderPath) {
            _this3.updating.next({
              status: _this3.updateStatusEnum.ERROR,
              err: "Can't update Firmware: 'loaderPath' is empty or 'null'"
            });

            return;
          }

          var data = {
            board: boardId,
            port: port,
            commandline: "\"{runtime.tools.fwupdater.path}/".concat(updaterBinaryName, "\" -flasher {network.password} -port {serial.port} -restore_binary \"{build.path}/{build.project_name}.bin\" -programmer ").concat(programmer),
            hex: '',
            extra: {
              auth: {
                password: "".concat(_this3.loaderPath, " -firmware ").concat(_this3.firmwareVersionData.Path, " ").concat(addresses)
              }
            },
            signature: isUsingAvrdude ? signaturesEnum.UPLOAD_FIRMWARE_AVRDUDE : signaturesEnum.UPLOAD_FIRMWARE_BOSSAC,
            filename: 'CheckFirmwareVersion.bin'
          };
          fetch("".concat(_this3.Daemon.pluginURL, "/upload"), {
            method: 'POST',
            headers: {
              'Content-Type': 'text/plain; charset=utf-8'
            },
            body: JSON.stringify(data)
          }).then(function (response) {
            if (!response.ok) {
              _this3.updating.next({
                status: _this3.updateStatusEnum.ERROR,
                err: "Can't update Firmware: error fetching ".concat(_this3.Daemon.pluginURL, "/upload")
              });
            }
          })["catch"](function (reason) {
            _this3.updating.next({
              status: _this3.updateStatusEnum.ERROR,
              err: "Can't update Firmware: ".concat(reason)
            });
          });
        });

        _this3.getFirmwareInfo(boardId, port, firmwareVersion);
      });
    }
  }]);

  return FirmwareUpdater;
}();

export { FirmwareUpdater as default };